import { type InitFlowComponent } from '@capsicum/common';
import { useEffect } from 'react';
import { osName } from 'react-device-detect';

import PWAForceInstallFlow from './pwa-force-install-flow';

export const PwaForceInstallFlowAndroid: InitFlowComponent = ({ fallback, isReactive, next }) => {
	const isVisible = isReactive && osName.toLocaleLowerCase() === 'android';

	useEffect(() => {
		if (!isVisible) {
			next();
		}
	}, [next, isVisible]);

	return !isVisible ? fallback : <PWAForceInstallFlow fallback={fallback} isReactive={isReactive} next={next} />;
};

PwaForceInstallFlowAndroid.keepAlive = true;
